import React from "react";
import "./Policy.css";

function Policy() {
  return (
    <div className="policy-page">
      <header className="policy-page-header">
        <img
          src={require("./abadata_logo_light.png")}
          alt="AbaData"
          className="policy-logo"
        />
      </header>

      <main className="policy-main">
        <article className="policy-card">
          <p className="policy-eyebrow">FieldOps</p>
          <h1 className="policy-title">Privacy Policy</h1>
          <p className="policy-effective-date">Effective date: 2026-03-30</p>

          <p>
            AbaData Inc. built the FieldOps app as a business
            application for field operations, inspections, inventory, mapping,
            notifications, and related workflow activities. This Privacy Policy
            explains how we access, collect, use, store, and share information
            when FieldOps is used.
          </p>

          <p>By using FieldOps, you agree to this Privacy Policy.</p>

          <section className="policy-section">
            <h2>Information We Collect</h2>
            <p>Depending on how the app is used, we may collect and process:</p>
            <ul>
              <li>
                account information, such as username, user ID, name, and
                organization or contract identifiers;
              </li>
              <li>
                field-work data, such as inspections, inventory records,
                schedules, notes, responses, work status, and related
                operational records;
              </li>
              <li>
                attachments and media, such as photos, files, and documents
                added to forms, inspections, or records;
              </li>
              <li>
                location data, including approximate location, precise
                location, and, where enabled, background location;
              </li>
              <li>notification data, such as push notification tokens;</li>
              <li>
                device and diagnostic information, such as device model,
                operating system, app version, IP address, timestamps, crash
                information, and error logs; and
              </li>
              <li>
                locally stored offline data used to operate the app when
                network access is limited.
              </li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>Location Data</h2>
            <p>
              FieldOps accesses location data. This includes approximate
              location, precise location, and, where enabled for your
              organization or workflow, background location.
            </p>
            <p>We may collect and use location data to:</p>
            <ul>
              <li>display maps and location-based records;</li>
              <li>
                capture location as part of inspections, forms, inventory, or
                work activity;
              </li>
              <li>
                support navigation, check-in, lone-worker, or safety-related
                workflows;
              </li>
              <li>
                support device-location broadcasting or scheduled location
                reporting when enabled; and
              </li>
              <li>
                sync operational location records with our systems or your
                organization’s systems.
              </li>
            </ul>
            <p>
              Location data may be accessed and collected while you are
              actively using the app. If background location features are
              enabled, location data may also be accessed while the app is
              running in the background.
            </p>
            <p>
              Location data may be stored locally on the device for offline use
              and later synced to our servers, your organization’s systems, or
              service providers acting on our behalf.
            </p>
          </section>

          <section className="policy-section">
            <h2>How We Use Information</h2>
            <p>We use collected information to:</p>
            <ul>
              <li>authenticate users and manage access to the app;</li>
              <li>
                provide field operations, inspection, inventory, mapping,
                attachment, and notification features;
              </li>
              <li>save, process, and sync work records;</li>
              <li>support location-based and safety-related workflows;</li>
              <li>maintain, troubleshoot, secure, and improve the app; and</li>
              <li>send operational notifications and provide support.</li>
            </ul>
          </section>

          <section className="policy-section">
            <h2>Camera, Files, and Media</h2>
            <p>
              The app may use the device camera and device files so users can
              capture or attach photos and documents to records in the app.
              These files may be stored locally and uploaded as part of app
              functionality.
            </p>
          </section>

          <section className="policy-section">
            <h2>Offline Storage</h2>
            <p>
              FieldOps may store information locally on the device, including
              records, attachments, settings, queued sync data, and
              location-related records, so the app can continue to function
              offline and sync later.
            </p>
          </section>

          <section className="policy-section">
            <h2>Sharing of Information</h2>
            <p>We may share information:</p>
            <ul>
              <li>
                with your employer, customer organization, or authorized
                administrators;
              </li>
              <li>
                with service providers and vendors that help us operate, host,
                support, secure, analyze, or improve the app;
              </li>
              <li>
                with third-party services used for notifications, diagnostics,
                analytics, logging, mapping, or related app operations; and
              </li>
              <li>
                when required by law or necessary to protect rights, safety,
                security, or legal compliance.
              </li>
            </ul>
            <p>
              This sharing may include location data where needed to provide
              the app’s functionality.
            </p>
            <p>We do not sell personal information.</p>
          </section>

          <section className="policy-section">
            <h2>Data Retention</h2>
            <p>
              We retain information for as long as reasonably necessary to
              provide the app, support operations, maintain records, comply
              with legal obligations, resolve disputes, and enforce agreements.
              Retention may vary based on customer configuration and operational
              requirements.
            </p>
          </section>

          <section className="policy-section">
            <h2>Security</h2>
            <p>
              We use commercially reasonable administrative, technical, and
              physical measures to protect information processed through the
              app and our backend systems.
            </p>
          </section>

          <section className="policy-section">
            <h2>Children’s Privacy</h2>
            <p>
              FieldOps is intended for business use and is not directed to
              children under 13. We do not knowingly collect personal
              information from children under 13.
            </p>
          </section>

          <section className="policy-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Updated
              versions will be posted with a revised effective date.
            </p>
          </section>

          <section className="policy-section">
            <h2>Contact Us</h2>
            <p>If you have questions about this Privacy Policy, contact:</p>
            <p className="policy-contact">
              <span>AbaData Inc.</span>
              <span>
                Email:{" "}
                <a href="mailto:support@abadata.ca">
                  support@abadata.ca
                </a>
              </span>
            </p>
          </section>
        </article>
      </main>
    </div>
  );
}

export default Policy;
